import { Sidebar } from "../Layout/Sidebar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddMenu = () => {
  const [title, setTitle] = useState('');
  const [link, setLink] = useState('');
  const [description, setDescription] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [menus,setMenus]=useState([])
  const [parentId, setParentId] = useState()
  const send = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/menu', true).post({
      title: title,
      description: description,
      link: link,
      parentId: parentId
    })
    
    if(res.code == 200){
      Swal.fire({
        title: 'موفق',
        text: 'منو با موفقیت ساخته شد',
        icon: 'success',
        confirmButtonText: 'متوجه شدم'
      })
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      })
    }
    
    dispatch(setLoading(false));
  }
  const fetchData = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/menu', true).get();
    console.log(res)
    if(res.code == 200){
      setMenus(res.data);
    }
    
    dispatch(setLoading(false));
  };
  
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain main">
        <div className="addInfoHeader">
          <span className="dashboardHeader keepRight clickable" onClick={send}>
            ایجاد منو
          </span>
          <span>
            <h1 className="sideBarTitle">بازگشت به صفحه منو ها</h1>
             <h1 className="dashBoardTitle">افزودن منو جدید</h1>
          </span>
          <i className="backAdd clickable" onClick={() =>navigate("/menu/")}></i>
        </div>
        <section className="bottomSection">
          <h1 className="dashBoardTitle">اطلاعات منو</h1>
          <form className="addInfo">
            <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setTitle(input.target.value)}/>
            <label className="sideBarTitle" htmlFor="infoTitle">لینک</label>
            <input className="addInput" id="infoTitle" onChange={(input: any) => setLink(input.target.value)}/>
            <label className="sideBarTitle" >والد</label>
            <select className="selector" id="infoTitle" onChange={(input: any) => setParentId(input.target.value)}>
              <option value={null}>بدون والد</option>
              {menus?.map((menu: any) =>  <option value={menu.id}>{menu.title}</option>)}
            </select>
            <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
            <textarea className="addInput" placeholder="توضیحات" id="infoAmount" onChange={(input: any) => setDescription(input.target.value)}/>
          </form>
        </section>
      </main>
      </body>
    </>
  )
}
export default AddMenu;